import React from 'react';
import { Link } from 'react-router-dom';
import { isResourceId } from '@/utils/queryParams';
import './index.scss';

const UserProfileLink = ({ user, children, className = '' }) => isResourceId(user?.id)
  ? <Link className={`userProfileLink ${className}`} to={`/users/${user.id}`} aria-label={`查看${user.nickname || user.username || '用户'}的主页`}>{children}</Link>
  : <span className={className}>{children}</span>;
export default UserProfileLink;
